import { EditIcon } from "components/atoms/Icon";
import { Paragraph } from "components/atoms/Typography";
import useMeasureSidebarState from "recoilStore/CustomPlan/useMeasureSidebarState";
import Tooltip from "components/atoms/Tooltip";
import styles from "./EditCustomPlanButton.module.scss";

interface EditCustomPlanButtonProps {
    selectedCustomPlanLength: number;
}

function EditCustomPlanButton({ selectedCustomPlanLength }: EditCustomPlanButtonProps) {
    const { setState: setMeasureSidebarState } = useMeasureSidebarState();
    const isMultipleSelected = selectedCustomPlanLength > 1;
    const warningMessage = "You can only edit one measure at a time. Select one measure only.";

    const button = (
        <button
            className={styles.editCustomPlanButton}
            type="button"
            onClick={() =>
                selectedCustomPlanLength === 1 &&
                setMeasureSidebarState((prevState) => ({
                    ...prevState,
                    isEditOpen: true,
                }))
            }
            disabled={selectedCustomPlanLength !== 1}
        >
            {selectedCustomPlanLength >= 1 && (
                <>
                    <EditIcon
                        color={selectedCustomPlanLength !== 1 ? "var(--audette-gray-400)" : "var(--audette-gray-600)"}
                    />
                    <Paragraph>{selectedCustomPlanLength > 1 ? "Edit (1 Measure Max)" : "Edit"}</Paragraph>
                </>
            )}
        </button>
    );

    return isMultipleSelected ? <Tooltip tooltipBody={warningMessage}>{button}</Tooltip> : button;
}

export default EditCustomPlanButton;
